export enum SalesForceIntegration {
  Inherited = 'inherited',
  Disabled = 'disabled',
}
